import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Button, Dropdown } from "react-bootstrap";

import BaseActionForm from '../BaseActionForm';

import './styles.scss'
import LeftPanelHeader from './../../components/LeftPanelHeader';

import { checkActiveProcess } from '../../utils/ProcessFunctions.js';
import * as actionTypes from "../../services/StoreContainer/actionTypes";

export default function Decomposer(props) {
    const dispatch = useDispatch();
    const datasetsContainer = useSelector((store) => { return store.datasetsReducer })

    const [taskState, setTaskState] = useState({ state: "", progress: 0, progressUpdate: false });

    useEffect(() => {
        if (datasetsContainer && datasetsContainer.selectedDataset.runningTasks.length) {
            const task = datasetsContainer.selectedDataset.runningTasks.find(task => task.performer === "lk_decomposer")
            if (task) {
                console.log(task, task.lastInfo.progress)
                let newTaskState = { state: "", progress: task.lastInfo.progress, progressUpdate: false };

                if ((taskState.state === "" || taskState.state === "running") && !task.lastInfo.completed)
                    newTaskState = {
                        state: "running",
                        progress: task.lastInfo.progress !== taskState.progress ? task.lastInfo.progress : taskState.progress,
                        progressUpdate: task.lastInfo.progress !== taskState.progress
                    };

                if (taskState.state === "" && task.lastInfo.completed)
                    newTaskState = {
                        state: "running",
                        progress: "finish",
                        progressUpdate: true
                    };

                setTaskState(newTaskState);
            } 
        }
        else {
            if (taskState.state === "running") setTaskState({ state: "finish", progress: 1, progressUpdate: true })
        }
        //eslint-disable-next-line
    }, [datasetsContainer.selectedDataset.runningTasks])

    return <DecomposerClass
        {...props}
        dispatch={dispatch}
        datasetsContainer={datasetsContainer}
        progressBar={<>
            <p className={'infoProcesses2'} style={{ display: 'inline' }}>
                Дождитесь завершения запущенных процессов
                {taskState && taskState.progress
                    ? ": пройдено " + Math.round(taskState.progress * 100) + "%"
                    : (taskState.state === "finish" ? ": пройдено 100%. Можно закрыть данное окно" : ": пройдено 0%")}
            </p>
        </>}
    />
}

class DecomposerClass extends BaseActionForm {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dataset: null,
            fields: null,
            selectedField: null
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        let dataset = this.props.datasetsContainer.selectedDataset;
        this.handleDatasetSelect(dataset);
    }

    handleDatasetSelect = (dataset) => {
        let stringFields = [];
        if (dataset) {
            dataset.fields.forEach((field) => {
                if (field.type === "string") {
                    stringFields.push(field);
                }
            });
        }
        this.setState(
            {
                dataset: dataset,
                fields: stringFields,
                selectedField: null
            }, () => {
                if (dataset) {
                    this.setState({ activeProcess: checkActiveProcess(dataset, 'lk_decomposer') });
                }
                this.datasetProcessCheck(dataset)
            }
        );
    }
    updateAndCheckDataset = (dataset) => {
        if (dataset) {
            let datasets = this.props.datasetsContainer.datasets;

            datasets.forEach((newDataset) => {
                if (newDataset._id === dataset._id) {
                    this.setState({
                        dataset: newDataset,
                        activeProcess: checkActiveProcess(newDataset, 'lk_decomposer')
                    });
                }
            })


        }
    }
    datasetProcessCheck = (dataset) => {
        this.checkInterval && clearInterval(this.checkInterval);
        if (dataset) {
            this.checkInterval = setInterval(() => {
                this.startLoading();
                this.updateAndCheckDataset(dataset)
            }, 5000);
        }
    }

    handleFieldSelect = (field) => {
        this.setState({ selectedField: field });
    }

    onStartProcess = () => {
        if (this.state.dataset && !this.state.buttonJustPressed && this.state.selectedField) {

            this.setState({ buttonJustPressed: true });

            this.lkApi.lKDecomposerTask(this.state.dataset.dataset, this.state.selectedField.name).then((response) => {
                console.log(response);

                this.setState({
                    activeProcess: checkActiveProcess(this.state.dataset, 'lk_decomposer')
                });
                setTimeout(() => {
                    this.setState({ buttonJustPressed: null })
                }, 5000);
            });
        }
    }

    render() {
        return (
            <div className='twoHalfs'>
                <div id={"decomposer"} className={"flexColumn rightPanel"}>
                    {this.renderAlerts()}

                    <LeftPanelHeader
                        dataset={this.state.dataset}
                        sectionName={this.sectionName(actionTypes.DECOMPOSER)}
                    />

                    <div className="postHeaderContainer textRoboto infoContainer">

                        {this.state.activeProcess &&
                            <div>
                                {this.props.progressBar}
                                {this.state.activeProcess && this.state.activeProcess.lastInfo && this.state.activeProcess.lastInfo.errors && this.state.activeProcess.lastInfo.errors.length > 0 &&
                                    <p>{this.state.activeProcess.lastInfo.errors.join(" ")}</p>
                                }
                            </div>
                        }

                        {this.state.dataset && this.state.fields && !this.state.activeProcess &&
                            <>
                                <p className="textBottom">Поле с адресом для разбора</p>
                                <Dropdown className="dropDecomposer">
                                    <Dropdown.Toggle className="dropdownButtonDecomposer" variant="success" id="dropdown-basic">
                                        {this.state.selectedField ? this.state.selectedField.caption : "Выберите"}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {this.state.fields.map((field, index) => (
                                            <Dropdown.Item key={index} onClick={() => { this.handleFieldSelect(field) }}>{field.caption}</Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </>
                        }
                    </div>
                    {(this.state.dataset && this.state.selectedField && !this.state.activeProcess) &&
                        <Button className='applyInstrument' style={this.state.buttonJustPressed ? { opacity: '0.3', pointerEvents: 'none' } : { opacity: '1' }} onClick={this.onStartProcess}>Запустить разбор адреса</Button>
                    }

                </div>

                <div className='rightHalf'></div>

            </div>
        );
    }
}

